import { createContext, useContext } from 'react';
import { DEFAULT_WORKFLOW_RENDER_CATALOG } from './default-workflow-render-catalog';
import type { WorkflowRenderCatalog } from './types';

export { WorkflowRenderCatalogProvider } from './workflow-render-catalog-provider';

export const WorkflowRenderCatalogContext =
  createContext<WorkflowRenderCatalog | null>(null);

export function useWorkflowRenderCatalog(): WorkflowRenderCatalog {
  const catalog = useContext(WorkflowRenderCatalogContext);
  return catalog ?? DEFAULT_WORKFLOW_RENDER_CATALOG;
}

export {
  DEFAULT_WORKFLOW_RENDER_CATALOG,
  listModelDescriptors,
  resolveGraphNodeRenderableNode,
  resolveGraphNodeRenderableNodeByViewData,
  resolveTriggerRenderableNode,
} from './default-workflow-render-catalog';
export { WORKFLOW_RENDER_NODE_KEYS } from './workflow-render-catalog-keys';
export type {
  WorkflowDisposable,
  WorkflowGraphNodeFlowRenderProps,
  WorkflowGraphNodeRenderableNode,
  WorkflowGraphNodeViewModelHandle,
  WorkflowNodeModelFactoryContext,
  WorkflowRenderableNode,
  WorkflowRenderableNodeModelEntry,
  WorkflowRenderableNodeModelMode,
  WorkflowRenderableNodeModels,
  WorkflowRenderCatalog,
  WorkflowRenderView,
  WorkflowTriggerRenderableNode,
} from './types';
